<template>
  <div>
    <div class="head pt-34">
      <div class="main-width">
        <h2 class="text-5xl text-white text-center font-medium">
          上船吧高端定制游
        </h2>
        <el-image
          class="block mx-auto w-[694px] mt-16"
          fit="cover"
          src="~@/assets/img/product/custom-travel/steps.png"
        />
        <div class="content mt-16 p-6">
          <el-form
            ref="form"
            class="apply-form"
            label-position="top"
            size="medium"
            :model="formData"
            :rules="formRules"
            @submit.native.prevent="onSubmit"
          >
            <div class="apply-form-title text-center pt-[85px]">
              <span
                class="apply-form-title__name text-dark font-medium text-2xl"
                >快速填写定制需求</span
              >
            </div>
            <div class="apply-form-body w-[415px] mx-auto mt-7">
              <div class="flex">
                <el-form-item class="w-36" label="出发地" prop="departure">
                  <el-input
                    v-model="formData.departure"
                    placeholder="请输入出发地"
                  />
                </el-form-item>
                <el-form-item class="flex-1">
                  <template #label>
                    <span class="text-white select-none">中间</span>
                  </template>
                  <div class="flex items-center justify-center h-8">
                    <el-image
                      class="w-10 mx-auto flex items-center justify-center"
                      src="~@/assets/img/product/custom-travel/right.png"
                      fit="cover"
                    />
                  </div>
                </el-form-item>
                <el-form-item class="w-36" label="目的地" prop="destination">
                  <el-input
                    v-model="formData.destination"
                    placeholder="请输入目的地"
                  />
                </el-form-item>
              </div>
              <el-form-item label="联系电话" prop="contact_mobile">
                <el-input
                  v-model="formData.contact_mobile"
                  maxlength="11"
                  placeholder="请输入联系电话"
                />
              </el-form-item>
              <el-form-item label="其他需求" prop="content">
                <el-input
                  v-model="formData.content"
                  type="textarea"
                  resize='none'
                  placeholder="请输入其他需求"
                />
              </el-form-item>
              <div class="apply-form-submit text-center">
                <div class="apply-form-submit__tip mb-3 mt-4 point-default">
                  专业定制师将在1小时内与您取得联系
                </div>
                <el-button
                  class="block w-full"
                  type="primary"
                  native-type="submit"
                  :loading="loading"
                  >需求提交</el-button
                >
              </div>
            </div>
            <ul class="flex service">
              <li class="service-item">
                <el-image
                  class="service-item__icon"
                  src="~@/assets/img/product/custom-travel/s_1.png"
                />
                <div class="service-item__text">专属服务</div>
              </li>
              <li class="service-item">
                <el-image
                  class="service-item__icon"
                  src="~@/assets/img/product/custom-travel/s_2.png"
                />
                <div class="service-item__text">高端品质</div>
              </li>
              <li class="service-item">
                <el-image
                  class="service-item__icon"
                  src="~@/assets/img/product/custom-travel/s_3.png"
                />
                <div class="service-item__text">出行保障</div>
              </li>
              <li class="service-item">
                <el-image
                  class="service-item__icon"
                  src="~@/assets/img/product/custom-travel/s_4.png"
                />
                <div class="service-item__text">稀有资源</div>
              </li>
            </ul>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { REQUEST_CODES } from "@/constants/const-http";

// api
import { submitCustomTravel } from "~/services/product";

export default {
  name: "CustomTravel",
  auth: false,
  data() {
    return {
      loading: false,
      formData: {
        departure: "",
        destination: "",
        contact_mobile: "",
        content: ""
      },
      formRules: {
        departure: {
          required: true,
          message: "请输入出发地"
        },
        destination: {
          required: true,
          message: "请输入目的地"
        },
        contact_mobile: {
          required: true,
          message: "请输入联系电话"
        }
      }
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        this.loading = true;
        let { code, msg } = await submitCustomTravel(this.formData);
        this.loading = false;
        if (code !== REQUEST_CODES.ERROR_OK) {
          this.$message.error(msg);
          return;
        }
        // this.$message.success(msg)
        this.$alert(msg, "提交成功", {
          confirmButtonText: "返回首页",
          type: "success",
          center: true,
          showCancelButton: false,
          callback: () => {
            this.$router.push("/index");
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.head {
  background: url("~@/assets/img/product/custom-travel/head-banner.png") top
      center no-repeat;
  background-size: 1920px 540px;
  min-height: 540px;
}
::v-deep .apply-form {
  background: url("~@/assets/img/product/custom-travel/form-bg.png") center
      center no-repeat;
  background-size: 1100px 780px;
  height: 780px;
  width: 1100px;
  margin: 0 auto;
}
::v-deep .apply-form-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
::v-deep .apply-form-title::before, ::v-deep .apply-form-title::after {
  content: "";
  display: inline-block;
  background: center center no-repeat;
  background-size: cover;
  width: 66px;
  height: 7px;
}
::v-deep .apply-form-title::before {
  background-image: url("~@/assets/img/product/custom-travel/title-right-bg.png");
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  -webkit-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -ms-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  --tw-rotate: 180deg;
}
::v-deep .apply-form-title::after {
  background-image: url("~@/assets/img/product/custom-travel/title-right-bg.png");
}
::v-deep .apply-form-title__name {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
::v-deep .apply-form .el-form-item {
  margin-bottom: 1.25rem;
}
::v-deep .apply-form .el-form-item__label {
  font-weight: 500;
  line-height: 1.25rem;
  margin-bottom: 0.25rem;
  padding-bottom: 0px;
}
::v-deep .apply-form .el-input__inner, ::v-deep .apply-form .el-textarea__inner {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.service {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin-top: 2.5rem;
}
.service-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 108px;
  width: 142px;
}
.service-item__icon {
  width: 40px;
}
.service-item__text {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0.75rem;
}
</style>
